export type Locale = 'en' | 'ar'
export type Direction = 'ltr' | 'rtl'

export const translations = {
  en: {
    header: {
      about: 'About',
      corporateGovernance: 'Corporate Governance',
      advisorsAuditors: 'Advisors & Auditors',
      cardIssuing: 'Card Issuing & Management',
      atmAcquiring: 'ATM Acquiring',
      merchantAcquiring: 'Merchant Acquiring',
      mobilePayment: 'Mobile Payment',
      consultancy: 'Consultancy',
      otherServices: 'Other Services',
      ourTools: 'Our Tools',
      theGroup: 'The Group',
      businesses: 'Businesses',
      partners: 'Partners',
      contact: 'Contact',
    },
    hero: {
      slide1: {
        heading: 'Seamless Payments.\nSmarter Solutions.',
        description:
          'Driving growth through empowering your business with state-of-the-art technology, agility, and security.',
      },
      slide2: {
        heading: 'Global Reach.\nLocal Expertise.',
        description:
          'Connecting businesses across 30+ countries with tailored payment solutions built for every market.',
      },
      learnMore: 'Learn More',
      scrollDown: 'Scroll Down',
    },
    stats: {
      clients: 'Clients',
      countries: 'Countries',
      experience: 'Year of Experience',
      employees: 'Employees',
    },
    about: {
      theGroup: 'The Group',
      description:
        'We empower financial ecosystems across more than 30 markets in the European, MENA, Central Asian, and Sub-Saharan Africa regions, partnering with over 100 banks and financial institutions to drive efficiency, scalability, and digital transformation.',
      learnMore: 'Learn More',
    },
    services: {
      title: 'Our Services',
      cardIssuing: {
        title: 'Card Issuing',
        description:
          'We offer comprehensive, end-to-end solutions for both physical and digital card programs.',
      },
      atmAcquiring: {
        title: 'ATM Acquiring',
        description:
          'Empowers financial institutions with seamless connectivity to local and international networks.',
      },
      mobilePayments: {
        title: 'Mobile Payments',
        description:
          "We enable financial institutions to meet the demands of today's digital-first users.",
      },
      merchantAcquiring: {
        title: 'Merchant Acquiring',
        description:
          'Flexible and scalable Merchant Acquiring platform designed to support businesses.',
      },
      consultancy: {
        title: 'Consultancy',
        description:
          'Consultancy services to help institutions navigate the complexities of the payments.',
      },
    },
    appExperience: {
      title: 'The App Experience',
      manageAccounts: {
        title: 'Manage All Card Accounts',
        content:
          "For access to all information related to their cardholders' accounts or transactions in a real-time online fashion.",
      },
      transactionSummary: {
        title: 'Transaction Summary',
        content:
          'View detailed transaction histories, filter by date or type, and export reports instantly.',
      },
      accountSummary: {
        title: 'Account Summary',
        content:
          'Get a comprehensive overview of your account balances, limits, and status at a glance.',
      },
      learnMore: 'Learn More',
    },
    security: {
      security: {
        title: 'Security',
        subtitle: '& Compliance',
        description:
          'We offer comprehensive risk and compliance management, including twice-daily card scrubbing against OFAC and other regulatory lists. Our tailored fraud detection and management solutions ensure robust protection, while dedicated customer support handles chargebacks and disputes efficiently.',
      },
      fraud: {
        title: 'Fraud',
        subtitle: '& Prevention',
        description:
          'Advanced fraud detection systems powered by machine learning analyze transactions in real-time, identifying suspicious patterns and preventing unauthorized access before it impacts your business.',
      },
      data: {
        title: 'Data',
        subtitle: '& Protection',
        description:
          'End-to-end encryption and secure data handling practices ensure your sensitive information remains protected at every stage of the transaction process, meeting global compliance standards.',
      },
    },
    partners: {
      description:
        'CSC Group Endeavors to facilitate commercial transactions through easy, direct, and targeted electronic payments. Over and above, CSC Group provides electronic and digital solutions that help businesses and clients obtain what they need in the shortest time possible.',
      learnMore: 'Learn More',
    },
    trusted: {
      title: 'Trusted By\nGlobal Leaders',
      description:
        "We are proud to partner with some of the world's most respected financial networks and institutions to deliver world-class payment solutions.",
      learnMore: 'Learn More',
    },
    footer: {
      company: 'Company',
      services: 'Services',
      support: 'Support',
      about: 'About',
      history: 'History',
      missions: 'Missions & Vision',
      partners: 'Our Partners',
      news: 'News',
      publications: 'Publications',
      mobileApp: 'Mobile App',
      cardIssuing: 'Card Issuing & Management',
      atmAcquiring: 'ATM Acquiring',
      merchantAcquiring: 'Merchant Acquiring',
      dataCenters: 'Data Centers & Connections',
      mobilePayment: 'Mobile Payment',
      consultancy: 'Consultancy',
      otherServices: 'Other Services',
      beyondCore: 'Beyond The Core',
      tools: 'Tools',
      careers: 'Careers',
      contact: 'Contact us',
      privacy: 'Privacy Policy & Legal',
      dataPrivacy: 'Data Privacy Policy',
      copyright: '©2026 CSC Group , All Rights Reserved',
    },
    aboutPage: {
      hero: {
        title: 'ABOUT',
        subtitle:
          'Since our incorporation in 1993, CSC boasts over 30 years of proven expertise, establishing itself as a trusted leader in secure and innovative payment solutions.',
      },
      description: {
        paragraph1:
          'We empower financial ecosystems across more than 30 markets in the European, MENA, Central Asian, and Sub-Saharan Africa regions, partnering with over 100 banks and financial institutions to drive efficiency, scalability, and digital transformation.',
        paragraph2:
          "Operating from 4 strategically located sites, CSC Group delivers agile, future-ready technologies that meet the evolving needs of today's financial landscape, whether in card issuing, acquiring, or digital payments.",
      },
      teamQuote:
        'Our strength lies in our people, a diverse team of 200+ professionals committed to excellence, innovation, and client success.',
      mission: {
        label: 'Our Mission',
        heading:
          'Our mission is to empower our clients by delivering secure, innovative, and seamless payment processing solutions.',
        description:
          'We are committed to building trust through superior technology, exceptional service, and unwavering integrity, driving financial inclusion and growth for our clients and their communities.',
      },
      vision: {
        label: 'Our Vision',
        heading:
          'To lead the evolution of digital payments, pioneering secure innovations',
        description:
          'that unlock financial empowerment and prosperity for businesses and communities across our key markets.',
      },
      cta: {
        heading: 'Join Our\nBold Thinkers',
        description:
          "We're building the future of payments and we're looking for bold thinkers to join us.",
        button: 'Join Today',
      },
    },
    cardIssuingPage: {
      hero: {
        title: 'Card\nIssuing',
        subtitle:
          'End-to-end solutions for physical and digital card programs, from instant issuance to full lifecycle management.',
      },
      services: {
        licensing: 'Licensing',
        programLaunching: 'Program Launching',
        cardIssuingProcess: 'Card Issuing Process',
        cardManagement: 'Card Management Activities',
      },
      description: {
        paragraph1:
          'We offer comprehensive, end-to-end solutions for both physical and digital card programs. From issuance and personalization to secure lifecycle management and settlement, our platform supports a wide range of card types (credit, debit, prepaid, and virtual).',
        paragraph2:
          "Whether you're launching a new card program or scaling an existing one, we provide the flexibility, compliance, and performance needed to deliver seamless cardholder experiences and operational efficiency.",
      },
      features: {
        replicatedData: 'Replicated Data',
        flexibleReporting: 'Flexible Reporting',
        automatedCardLoading: 'Automated Card Loading',
        atmCashDeposits: 'ATM Cash Deposits*',
        advancedApiIntegration: 'Advanced API Integration',
        customerSupport: '24/7 Customer Support',
        issuerCmsAccess: 'Issuer CMS Access',
        ofacScrubbing: 'OFAC & Other List Scrubbing',
        pinBySms: 'PIN by SMS/Email',
        dailyReconciliation: 'Daily Reconciliation',
        secureTransaction: '3D Secure Transaction Support',
        fraudMonitoring: '24/7 Fraud Monitoring',
        instantIssuance: 'Instant Card Issuance',
        chargeBackSupport: 'Charge Back/Dispute Support',
        continuousTraining: 'Continuous Training',
        settlementAssociations: 'Settlement with Card Associations',
        dayToDaySupport: 'Day-to-Day Management Support',
        bankingAppIntegration: 'Full Integration to Banking APP',
      },
      cardTypes: {
        heading:
          'CSC offers a comprehensive range of card types to support the evolving needs of your business',
        imageAlt:
          'Card types offered by CSC: Prepaid, Debit, Credit, Charge, Virtual, Co-branded, and Corporate cards',
      },
      moreServices: 'More Services',
    },
    merchantAcquiringPage: {
      hero: {
        title: 'Merchant\nAcquiring',
        subtitle:
          'Powerful tools for merchant onboarding, transaction processing, and POS management built to scale with your business.',
      },
      description: {
        paragraph1:
          'We provide a flexible and scalable Merchant Acquiring platform designed to support businesses of all sizes whether face-to-face or e-commerce. From fast and seamless merchant onboarding to secure transaction processing and centralized POS/e-commerce management, our solutions help institutions deliver smooth payment experiences across every touchpoint.',
        paragraph2:
          'With real-time analytics, multi-channel support, and integration with major payment schemes; we enable you to grow your merchant network, optimize operations, and stay ahead in a rapidly evolving market.',
      },
      features: {
        posEcommerce: 'POS & E-commerce',
        statisticsDashboard: 'Statistics Dashboard Access',
        fraudMonitoring: '24/7 Fraud Monitoring',
        disputesManagement: 'Disputes Management and Processing',
        mpos: 'mPOS',
        accountManagement: 'Full Account Management Cycle',
        merchantInternet: 'Merchant Internet Access',
        dcc: 'DCC',
        flexibleReporting: 'Flexible Reporting',
        customerSupport: '24/7 Customer Support',
      },
      moreServices: 'More Services',
    },
    atmAcquiringPage: {
      hero: {
        title: 'ATM\nAcquiring',
        subtitle:
          'A robust acquiring platform that connects your ATMs to major networks with real-time monitoring, reporting, and secure transaction handling.',
      },
      description: {
        paragraph1:
          'Our ATM Acquiring platform empowers financial institutions with seamless connectivity to local and international networks. Designed for reliability and scale, it ensures secure transaction processing, real-time monitoring, and detailed reporting across your entire ATM network.',
        paragraph2:
          "Whether expanding your network or enhancing operational efficiency; CSC's platform delivers the infrastructure and insights needed to optimize performance and improve customer access - anytime, anywhere.",
      },
      features: {
        atmDriving: 'ATM Driving and Management',
        atmReconciliation: 'ATM Reconciliation',
        cashChequeDeposit: 'Cash and Cheque Deposit',
        utilityPayments: 'Utility Payments',
        support247: '24/7 Support',
        fraudMonitoring: '24/7 Fraud Monitoring',
        flexibleReporting: 'Flexible Reporting',
        disputeManagement: 'Disputed Management and Processing',
        accessFee: 'Access Fee',
        dcc: 'DCC',
      },
      moreServices: 'More Services',
    },
    mobilePaymentsPage: {
      hero: {
        title: 'Mobile\nPayments',
        subtitle:
          "Tap into the future with mobile wallet solutions, tokenization, and contactless integrations tailored to today's users.",
      },
      description: {
        paragraph1:
          "We enable financial institutions to meet the demands of today's digital-first users through secure, seamless mobile payment solutions. Our platform supports mobile wallets, tokenization, and contactless integrations, ensuring fast, flexible, and frictionless transactions across devices.",
        paragraph2:
          "Whether launching your own branded application or wallet or integrating with our white label application, we provide the tools, compliance, and technology to help you stay connected, competitive, and ready for what's next.",
      },
      moreServices: 'More Services',
    },
    consultancyPage: {
      hero: {
        title: 'Strategic\nConsultancy',
        subtitle:
          'Expert guidance in payments strategy, compliance, and digital transformation, designed to help you lead with confidence.',
      },
      description: {
        paragraph1:
          'We offer strategic consultancy services to help institutions navigate the complexities of the payments landscape. From shaping your digital transformation roadmap to ensuring regulatory compliance and optimizing operational performance, our experts provide insights that turn challenges into opportunities.',
        paragraph2:
          'With deep regional expertise and decades of hands-on experience; we partner with you to build resilient strategies, unlock growth, and lead with clarity and confidence in an evolving financial ecosystem.',
      },
      moreServices: 'More Services',
    },
    otherServicesPage: {
      hero: {
        title: 'BEYOND THE CORE',
        subtitle:
          'Stay up to date and learn more about\nour new and upcoming services.',
      },
      services: {
        aftOct: {
          title: 'Full support of AFT & OCT Fund transfers',
          description:
            'Expert guidance in payments strategy, compliance, and digital transformation, designed to help you lead with confidence.',
        },
        bnpl: {
          title: 'Fully integrated BNPL (Buy Now Pay Later) Programs',
          description:
            'Expert guidance in payments strategy, compliance, and digital transformation, designed to help you lead with confidence.',
        },
        cardlessAtm: {
          title: 'Supporting Cardless & Contactless ATM Withdrawals & Deposits',
          description:
            'Expert guidance in payments strategy, compliance, and digital transformation, designed to help you lead with confidence.',
        },
        googlePay: {
          whatsNext: "What's Next?",
          title: 'Full support on Google Pay & Tokenization',
          description:
            'Expert guidance in payments strategy, compliance, and digital transformation, designed to help you lead with confidence.',
        },
      },
      moreServices: 'More Services',
    },
    ourToolsPage: {
      hero: {
        title: 'OUR TOOLS',
        subtitle:
          'Stay up to date and learn more about\nour new and upcoming services.',
      },
      tools: {
        cms: {
          title: 'Web Content Management Application (Web-Gui)',
          description:
            'Providing full access and management of functions and information related to cardholder accounts or transactions in a real-time online fashion.',
        },
        dataNavigator: {
          title: 'Data Navigator',
          description:
            "Provides access to detailed transaction information on the issuer's card accounts, as well as the bank's ATM/POS activity (if applicable).",
        },
        apiIntegration: {
          title: 'API Integration with Bank/Financial Institution App',
          description:
            'Obtain specific card account details including financial details, obtain specific card details such as card number and expiry date... Obtain transaction details related to a specific card account, make changes to the card account (card status, parameters, PIN change, etc.), and request card issuance.',
        },
        dataReplication: {
          title: 'Data Replication',
          description:
            'Provides issuers with the ability to access their data in raw format and the ability to extract reports and manage other services etc. from their side.',
        },
      },
    },
    mobileAppPage: {
      hero: {
        title: 'Mobile\nApp',
        subtitle:
          'Expert guidance in payments strategy, compliance, and digital transformation, designed to help you lead with confidence.',
      },
      description: {
        paragraph1:
          'View and manage all your cards, track account and billing summaries, monitor and filter transactions, dispute charges, change PINs, request e-statements, analyze spending behavior, and enjoy secure access with biometric authentication.',
      },
      appFeatures: {
        label: 'App Features',
        viewCards: '1. View all card accounts',
        manageCards: '2. Manage all card accounts',
        hideShow: 'Hide/Show',
        activateDeactivate: 'Activate/Deactivate',
        cancelCard: 'Cancel Card',
        accountSummary: '3. Account Summary',
        limit: 'Limit',
        totalBalance: 'Total Balance',
        availableToSpend: 'Available to Spend',
        minimumDue: 'Minimum Due',
        billingCycle: '4. Billing Cycle',
        transactionSummary: '5. Transaction Summary',
        latestTransactions: 'Latest Transactions',
        transactionFilter: 'Transaction Filter',
        transactionHistory: 'Transaction History',
        disputeTransaction: 'Dispute a Transaction',
        pinChange: 'PIN Change',
        requestEstatement: 'Request E-statement',
        spendingBehavior: 'Spending Behavior',
        biometricAuth: 'Biometric Authentication',
      },
    },
    careersPage: {
      hero: {
        title: 'CAREERS',
        subtitle:
          'At CSC Group, we believe that our success starts with our people.',
      },
      description:
        "We are passionate about innovation, excellence, and creating solutions that make an impact. Whether you're an experienced professional or just starting your career, we offer opportunities to grow, learn, and contribute to the future of financial services in Lebanon and beyond.",
      howToApply: {
        title: 'How to Apply?',
        text1:
          'To apply, please send your CV along with a brief cover letter to',
        text2:
          "using 'Job Application' as the subject line. Our recruitment team will carefully review your submission and reach out should your profile align with our current opportunities.",
      },
    },
    contactPage: {
      hero: {
        title: 'CONTACT US',
        subtitle:
          "We're here to help you with any inquiries or support you may need.",
      },
      offices: {
        cyprus: {
          title: 'Head Office Cyprus',
        },
        lebanon: {
          title: 'Lebanon:',
        },
        iraq: {
          title: 'Iraq:',
        },
        dataCenter: {
          title: 'Data Center & Disaster Recovery:',
        },
      },
      map: {
        ourClients: 'Our Clients',
        ourOffices: 'Our Offices',
      },
    },
    partnersPage: {
      hero: {
        title: 'Core\npartners',
        subtitle:
          'Our strongest achievements are built on the trust and collaboration we share with our partners.',
      },
      description: {
        paragraph1:
          'At CSC, collaboration is at the core of our success. We work hand in hand with banks, FinTechs, government institutions, regional payment networks, and card associations to create seamless, secure, and innovative financial solutions.',
        paragraph2:
          'Our enduring partnerships are built on a foundation of trust, reliability, and a commitment to excellence. Together, we drive growth, unlock new opportunities, and shape the future of the payments network throughout the region.',
      },
      grid: {
        filterAll: 'All',
        filterCardAssociations: 'Card Associations',
        filterSystemsCompliance: 'Systems Compliance',
        filterSoftwareHardware: 'Software & Hardware',
        filterDataCentres: 'Data Centres/DR Site',
        partnerDescription:
          'We work hand in hand with banks, FinTechs, government institutions, regional payment networks, and card associations to create seamless, secure, and innovative financial solutions.',
        noPartners: 'No partners found in this category.',
      },
      map: {
        title: 'Our Global Presence',
      },
    },
    publicationsPage: {
      hero: {
        title: 'Publications',
        subtitle:
          'Explore our latest reports, articles, and research papers showcasing insights and expertise.',
      },
      filterBy: 'Filter By',
      filters: {
        all: 'All',
        reports: 'Reports',
        articles: 'Articles',
        research: 'Research',
      },
    },
    newsPage: {
      hero: {
        title: 'IN THE NEWS',
        subtitle:
          'Catch up on our latest partnerships, product launches, and regional milestones.',
      },
      filters: {
        all: 'All News',
        partnerships: 'Partnerships',
        productLaunches: 'Product Launches',
        milestones: 'Milestones',
      },
      filterBy: 'Filter By',
      loadMore: 'LOAD MORE',
    },
    newsArticle: {
      backToNews: 'Back to News',
      readMore: 'Read More',
    },
    corporateGovernancePage: {
      hero: {
        title: 'Corporate\nGovernance',
        subtitle:
          'Strong leadership and clear governance guide everything we do.',
      },
      description: {
        paragraph1:
          'The Minds Powering CSC: At CSC Group, our strength lies in our people. From technology experts to industry leaders, each member of our team brings deep experience, fresh thinking, and a shared commitment to excellence.',
      },
      grid: {
        shareholders: 'Shareholders',
        boardOfDirectors: 'Board of Directors',
        executiveCommittee: 'Executive Committee',
        johnSmith: 'John Smith',
        jessicaDoe: 'Jessica Doe',
        reaJohnson: 'Rea Johnson',
        roleDescription:
          'Empowers financial institutions with seamless connectivity to local and international networks.',
      },
    },
    advisorsAuditorsPage: {
      hero: {
        title: 'Advisors\n& Auditors',
        subtitle:
          'Together, we collaborate, innovate, and lead with purpose, powering the growth of our clients and the future of payments.',
      },
      description: {
        paragraph1:
          'The Minds Powering CSC: At CSC Group, our strength lies in our people. From technology experts to industry leaders, each member of our team brings deep experience, fresh thinking, and a shared commitment to excellence.',
      },
      grid: {
        auditors: 'Auditors',
        advisors: 'Advisors',
        johnSmith: 'John Smith',
        jessicaDoe: 'Jessica Doe',
        reaJohnson: 'Rea Johnson',
        roleDescription:
          'Empowers financial institutions with seamless connectivity to local and international networks.',
      },
    },
    privacyPolicyPage: {
      title: 'PRIVACY POLICY & LEGAL',
      general: {
        heading: 'GENERAL',
        p1: 'This Privacy Policy describes the type of personal information we collect from our Clients and sets out the terms on which we use and process that information.',
        p2: '"Personal data" means any information relating to an identified or identifiable person ("Data Subject"). Identifiable person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as: name, a photograph, address, an e-mail, an identification number, location data, an online identifier – e.g. IP address, or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.',
        p3: 'CSC Europe Limited ("CSC Europe" and or "CSC") considers the protection and security of personal information fundamental right of each individual and takes the processing of such information responsibly. This Privacy Policy determines our obligations on one side and Clients\' rights on another, as provided by the new EU General Data Protection Regulation ("GDPR"), which came into force on 25 May, 2018 and was made directly applicable to all EU Member States. The Policy follows strictly the requirements of the Law Providing for the Protection of Natural Persons with Regard to the Processing of Personal Data and for the Free Movement of Such Data (Law 125(I) of 2018) as well.',
      },
      whyCollect: {
        heading: 'WHY WE COLLECT PERSONAL INFORMATION',
        p1: 'CSC Europe Limited is an Electronic Money Institution operating under license No. 115.1.3.2 granted by the Central Bank of Cyprus (www.centralbank.cy). As a regulated financial company we collect Customers data in order to comply with our legal obligations laid down by the rules governing our operations. CSC Europe uses personal information to identify and verify the Customers and support them with proper management of accounts and transactions, but also to reduce effectively any exposure to fraud.',
        p2: 'Our registered head office is located in Cyprus at: 23, Zachariadhes Court, 15, Nicodemou Mylona Street, Larnaca, 6010, Cyprus.',
        p3: 'Please contact us if you have any questions about how your personal information is used by us at e-mail CSCGRP-Compliance@cscgroup.com or by writing to us at the registered address specified above.',
      },
      consent: {
        heading: 'YOUR CONSENT',
        p1: 'By using our websites and our services you agree and accept the terms of this Privacy Policy and consent to the collection and use of your personal information in the manner described herein. You also warrant that all data provided by you in the course of our business relationship is accurate and up to date.',
      },
      changes: {
        heading: 'NOTIFICATION OF CHANGES',
        p1: "This Privacy Policy may be revised over time and we may change this Privacy Policy at any time by posting a revised version of it on our website. Unless we have legal grounds to do otherwise, we will provide you with at least 30 days' prior notice of the effective date of the revised Privacy Policy. We may post the notice on our website and/or send you the notice by e-mail. As of the effective date of the revised Privacy Policy, you will be considered as having consented to all changes to the Privacy Policy.",
        p2: "If you disagree with the terms of this Privacy Policy, you may end our agreement and close your account at any time. We encourage you to visit the Company's website periodically so as to keep updated on any subsequent changes in our Privacy Policy.",
        p3: 'This policy was last updated on 2nd October, 2025.',
      },
      infoCollect: {
        heading: 'TYPE OF PERSONAL INFORMATION AND DOCUMENTS WE COLLECT',
        p1: 'We collect personal information and documents about you when you apply to become a Client and open account with CSC Europe. This information may include: your name, date of birth, nationality, home address, details on occupation, contact information such as phone number and email address, but also identity verification information including: images of your government issued identity document (passport, national ID Card or driving license), residence verification information such as utility bill details or similar information. In some circumstances we may conduct a background check on your financial situation by obtaining information about your business and source of wealth, in order for us to comply with our legal obligations under the Prevention and Suppression of Money Laundering and Terrorist Financing Laws of 2007-2022 and the relevant Directives of the Central Bank of Cyprus.',
        device: 'Using your device:',
        p2: 'When you use CSC Europe services using any device, we may additionally collect and store device sign-on data (including but not limited to device ID) and location data in order to provide our services with the best user experience. We also collect the Internet address (IP address) and other identifying information about the computer or device you use to access your account or use our services in order to detect possible instances of unauthorized access to your account.',
        p3: 'We collect information on which pages of our website you visit, IP addresses, the type of browser you use and the times you access our website.',
        communications: 'Communications:',
        p4: 'When you communicate with us for customer service or other purposes (e.g., by e-mails, phone calls, faxes, etc.), we retain such information and our responses to you in the records of your account.',
      },
      cookies: {
        heading: 'COOKIE POLICY',
        whatAreCookies: 'What are cookies?',
        p1: "A cookie is a small file of letters and numbers downloaded on to a device (computer, smart phone etc.) when the user accesses certain websites. Cookies allow a website to recognize a user's device, remember essential information and work in a better, more efficient way.",
        categories: 'Different categories of cookies:',
        firstParty: 'First party cookies.',
        firstPartyDesc:
          'First party cookies are set by the website that the user is browsing and they can only be read by that particular website.',
        thirdParty: 'Third party cookies.',
        thirdPartyDesc:
          'Third party cookies are set by a different organization to the owner of the website that is visited. For example, the website might use a third party company who will set their own cookies to perform this service.',
        session: 'Session cookies.',
        sessionDesc:
          "Session Cookies are stored only temporarily during a browsing session and are deleted from the user's device when the browser is closed. Session cookies help our websites remember what you chose on a previous page, avoiding the need to re-enter information. Session cookies expire after a browser session ends, so are not stored long term.",
        persistent: 'Persistent cookies.',
        persistentDesc:
          'These type of cookies are saved on the computer for a fixed period (and are not deleted when the browser is closed). Persistent cookies are used where the website needs to know who you are for more than one browsing session. For example, these types of cookies are used to store the preferences, so that they are remembered for the next visit.',
        weUse: 'Cookies that we use:',
        p2: "We use two cookies which are essential for its backend server software (ColdFusion) to work properly: CFID and CFTOKEN. These are used as a pair to create a unique session ID in order that our web systems can uniquely identify a visitor's session. This information is not used or stored outside of our systems. No personal information of any kind, related to the visitor, is collected or stored in these cookies. These are session cookies and will expire when your session expires (i.e. when you close your browser or navigate to another page).",
        p3: 'We use third party and persistent cookies to provide you with additional website functionalities.',
        p4: 'Additional Information about cookies you can find at: http://www.allaboutcookies.org/',
        p5: 'By continuing to use our websites you agree to the use of these Cookies and to our Cookie Policy.',
      },
      howWeUse: {
        heading: 'HOW WE USE YOUR PERSONAL INFORMATION',
        p1: 'We use your personal information to service your account and to improve our service to you.',
        p2: 'We strictly obey to the following principles when using your personal data:',
        a: 'We are doing our very best to ensure that your personal information is processed lawfully, fairly and in a transparent manner',
        b: 'We limit the personal information collected from you to what is necessary in relation to the purposes for which it is processed and try to maintain this information accurate and up to date',
        c: 'We store your personal data for no longer periods than is necessary for the purposes for which it is processed. We will retain and use your information as required to comply with our legal obligations',
        d: 'We apply necessary measures to process Customers data in a manner that ensures its security, integrity and confidentiality',
        p3: 'CSC collects your personal information for the below stated purposes and you agree that we may use that information to:',
        useA: 'To verify your identity and comply with applicable laws and regulations relating to the prevention of money laundering and terrorist financing',
        useB: 'To process your transactions',
        useC: 'To manage risk, detect and prevent fraud or other illegal uses of our services',
        useD: 'To help us in responding to your requests for services and support',
        useE: 'To contact you and communicate to you information and updates related to your use of our services and any other important information',
        useF: 'To detect or remediate violations of our policies and applicable agreements',
      },
      communication: {
        heading: 'OUR COMMUNICATION WITH YOU',
        p1: 'We communicate with our Customers via email to provide the requested services. We may also communicate with Customers by phone to:',
        item1: 'Resolve complaints or claims',
        item2: 'Respond to requests for customer service',
        item3:
          'Inform on illegitimate use of accounts or suspicious transactions',
        item4:
          "Confirm information concerning a Customer's identity, business or account activity",
        p2: 'We use your email or physical address to confirm the opening of your account, to send you activation code of your pre-paid card, to send you information about changes to our products and services, and to send notices and other disclosures required by law.',
        p3: 'We may communicate with you as described above by SMS to send you transaction notification alerts or tokens to process certain transactions on your account.',
      },
      disclosure: {
        heading: 'DISCLOSURE OF YOUR PERSONAL INFORMATION TO THIRD PARTIES',
        p1: 'There are circumstances in which we may need to share your personal data. We may need to do this in order to help us carry out our operations.',
        p2: 'In processing your transactions we may disclose your Personal Information to third parties, to legal and regulatory authorities.',
        thirdParties: 'Disclosure to third parties',
        p3: 'Your information will not be sold, exchanged, or shared with any third parties without your consent, except where required by law.',
        p4: 'Third party service providers are contractually bound with us to protect and use your personal data only for the purposes for which it is disclosed and we ensure that such third parties are subject to the same protective rules as those described in this Privacy Policy.',
        p5: 'Third parties cannot use personally identifiable information about our Customers for any secondary purposes without your explicit consent.',
        p6: 'You agree that we may share your personal information with:',
        shareA:
          'third party service partners, who are acting on our behalf as data processors, with any member of our group or with our ultimate holding company',
        shareB:
          'selected third parties including business partners or agents for the performance of any contract we enter into with them or with you',
        thirdPartySites: 'Third Party Sites',
        p7: "If you open a CSC Europe account directly on a third party website or via a third party application, any information that you enter on that website or application (and not directly on a CSC Europe website) will be shared with the owner of the third party website or application. These sites are governed by the Merchant's own privacy policies and you are encouraged to review their privacy policies before providing them with personal information. CSC Europe is not responsible for the protection of personal data policy of those Merchants.",
        legalAuthorities: 'Disclosure to Legal Authorities',
        p8: 'We may share your Personal Information with Regulators, law enforcement agencies, data protection authorities, government officials or other authorities in the following situations:',
        legalA:
          'In connection with a formal request, subpoena, court order, or other legal procedure',
        legalB:
          'When we believe in good faith that the disclosure is necessary to prevent money laundering, terrorist financing, tax evasion or other illegal activity',
        legalC:
          'Disclosure is necessary to investigate violations of this Privacy Policy or our Terms and Conditions or to prevent financial loss',
        p9: 'By submitting your personal data, you consent to this disclosure, transfer or processing. We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy.',
      },
      storage: {
        heading: 'HOW WE STORE YOUR PERSONAL INFORMATION',
        p1: 'The Personal Information you provide to us is stored on our servers securely. Payment transactions are encrypted using strong encryption algorithms.',
        p2: 'You are responsible to keep strictly confidential any security credentials provided to you for access to our site and to your personal account. We ask you not to share them with anyone.',
      },
      retention: {
        heading: 'RETENTION OF YOUR PERSONAL INFORMATION',
        p1: 'In order to comply with our legal obligations regarding the prevention of money laundering and countering terrorist financing, we are required to keep the following documents and information about our Customers for at least five (5) years after the end of the business relationship:',
        a: 'Copies of documents and information required for compliance with the Customer due diligence requirements as determined in the Prevention and Suppression of Money Laundering and Terrorist Financing Laws of 2007-2022',
        b: 'Relevant evidence and records of transactions, which are necessary for the identification of transactions',
        c: 'Relevant correspondence documents with Customers',
        p2: 'We can retain personal documents and information of our Customers for additional five (5) years where further retention of documents and information is justified for the purpose of prevention, detection or investigation of money laundering and terrorist financing.',
        p3: 'By submitting your personal data, you agree to this storing and retention of your records. We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy.',
      },
      security: {
        heading: 'SECURITY OF YOUR PERSONAL INFORMATION',
        p1: 'We use a variety of security measures to ensure the confidentiality of your Personal Information and protect your Personal Information from loss, theft, unauthorized access, misuse, alteration or destruction. We conform to the PCI DSS standards and the General Data Protection Regulation (GDRP) for protection of data and have implemented security measures including, but not limited to:',
        item1: 'Restricted accesses to Personal Information',
        item2: 'Strict policies on user accesses',
        item3:
          'Transport Layer Security (TLS) to ensure the confidentiality of your information during transmission over internal or public network.',
        item4:
          'Systems hardening to protect our servers from vulnerabilities and attacks',
        item5:
          'Periodic testing to ensure that our security measures are adequate.',
        item6: 'Audit trails to track changes on your Personal Information',
        p2: 'To prevent data loss, the information is backed up regularly. All our databases use encryption to protect data at rest. Furthermore, all sensitive data is encrypted before being transferred electronically. Integrity controls are in place to prevent data alteration.',
        p3: 'Only authorized personnel are permitted access to your Personal Information, and these personnel are required to treat the information as highly confidential. The security measures will be reviewed regularly in light of new and relevant legal and technical developments.',
      },
      gdpr: {
        heading:
          'YOUR RIGHTS TO PROTECTION OF PERSONAL DATA UNDER THE NEW GDPR',
        p1: 'As an individual, you have certain rights under the GDPR regarding the use of your personal information. These rights include the following:',
        right1:
          'You have a right to access your personal information and know what data we hold on you and for what purpose it is processed. You can request us to provide you with this information made in writing, by either email or letter, together with photographic identification or additional documents we may require to confirm your identity. We will reply to you within a month time of the receipt of your request. That period may be extended by two further months where necessary in case your request is more complex. In such situation we will inform you of any such extension together with the reasons for the delay. We will reply to you by electronic means, unless otherwise requested by you.',
        right2:
          'You have the right to obtain without undue delay the rectification of inaccurate personal data we maintain for you. You can review the personal information you have provided us and make any desired changes to such information, or to the settings for your account, at any time by logging in to your account.',
        right3:
          'You have the right to object or restrict the processing of your personal information at any time.',
        right4:
          'You can instruct us to share your personal information with other parties subject to your written direction and explicit consent to do so.',
        right5:
          'You can withdraw your consent to process your personal data at any time.',
        p2: 'You can send these requests to e-mail: CSCGRP-Compliance@cscgroup.com or by post to the registered address of our Company.',
      },
      complain: {
        heading: 'IF YOU WISH TO COMPLAIN',
        p1: 'Our Company is responsible for ensuring that our day-to-day procedures comply with this Privacy Policy. If you want to exercise your right to access your information, have any questions about this Privacy Policy, or wish to lodge a complaint about how your personal data is used by CSC Europe, you can contact us electronically at the email address given above or by writing to our registered address.',
        p2: 'Upon receipt of your complaint we will investigate it and respond to you within a month time. Where this deadline cannot be observed, we will explain to you the reason and will notify to you the extended time for reply.',
        supervisory:
          'Your right to lodge a complaint with the Supervisory Authority',
        p3: 'Where you believe that CSC Europe has not resolved your complaint in satisfactory manner, you have the right to complain to the Supervisory Authority. Their details are:',
        office:
          'Office of the Commissioner for Personal Data Protection of Cyprus',
        address1: '1, Iasonos str., 1082 Nicosia',
        address2: 'P.O.Box 23378, 1682 Nicosia',
        tel: 'Tel: +357 22818456',
        fax: 'Fax: +357 22304565',
        email: 'Email: commissioner@dataprotection.gov.cy',
      },
    },
  },
  ar: {
    header: {
      about: 'عن المجموعة',
      corporateGovernance: 'حكومة الشركات',
      advisorsAuditors: 'المستشارون والمدققون',
      cardIssuing: 'إصدار وإدارة البطاقات',
      atmAcquiring: 'شبكة الصراف الآلي',
      merchantAcquiring: 'خدمات التجار',
      mobilePayment: 'الدفع عبر الهاتف المحمول',
      consultancy: 'الاستشارات',
      otherServices: 'خدمات أخرى',
      ourTools: 'أدواتنا',
      theGroup: 'المجموعة',
      businesses: 'الأعمال',
      partners: 'الشركاء',
      contact: 'اتصل بنا',
    },
    hero: {
      slide1: {
        heading: 'مدفوعات سلسة.\nحلول أذكى.',
        description:
          'ندفع عجلة النمو من خلال تمكين أعمالك بأحدث التقنيات والمرونة والأمان.',
      },
      slide2: {
        heading: 'وصول عالمي.\nخبرة محلية.',
        description:
          'نربط الشركات عبر أكثر من 30 دولة بحلول دفع مخصصة مصممة لكل سوق.',
      },
      learnMore: 'اعرف المزيد',
      scrollDown: 'مرر للأسفل',
    },
    stats: {
      clients: 'عميل',
      countries: 'دولة',
      experience: 'سنة خبرة',
      employees: 'موظف',
    },
    about: {
      theGroup: 'المجموعة',
      description:
        'نحن نمكن الأنظمة المالية البيئية عبر أكثر من 30 سوقاً في أوروبا والشرق الأوسط وشمال أفريقيا وآسيا الوسطى وأفريقيا جنوب الصحراء الكبرى، ونشترك مع أكثر من 100 بنك ومؤسسة مالية لدفع الكفاءة وقابلية التوسع والتحول الرقمي.',
      learnMore: 'اعرف المزيد',
    },
    services: {
      title: 'خدماتنا',
      cardIssuing: {
        title: 'إصدار البطاقات',
        description:
          'نقدم حلولاً شاملة ومتكاملة لبرامج البطاقات المادية والرقمية.',
      },
      atmAcquiring: {
        title: 'شبكة الصراف الآلي',
        description:
          'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
      },
      mobilePayments: {
        title: 'الدفع عبر الهاتف',
        description:
          'نمكن المؤسسات المالية من تلبية متطلبات المستخدمين الرقميين اليوم.',
      },
      merchantAcquiring: {
        title: 'خدمات التجار',
        description:
          'منصة مرنة وقابلة للتوسع لخدمات التجار مصممة لدعم الشركات.',
      },
      consultancy: {
        title: 'الاستشارات',
        description:
          'خدمات استشارية لمساعدة المؤسسات على التنقل في تعقيدات المدفوعات.',
      },
    },
    appExperience: {
      title: 'تجربة التطبيق',
      manageAccounts: {
        title: 'إدارة جميع حسابات البطاقات',
        content:
          'للوصول إلى جميع المعلومات المتعلقة بحسابات حاملي البطاقات أو المعاملات بشكل فوري عبر الإنترنت.',
      },
      transactionSummary: {
        title: 'ملخص المعاملات',
        content:
          'عرض سجلات المعاملات التفصيلية، والتصفية حسب التاريخ أو النوع، وتصدير التقارير فورياً.',
      },
      accountSummary: {
        title: 'ملخص الحساب',
        content: 'احصل على نظرة شاملة لأرصدة حسابك وحدوده وحالته في لمحة.',
      },
      learnMore: 'اعرف المزيد',
    },
    security: {
      security: {
        title: 'الأمان',
        subtitle: '& الامتثال',
        description:
          'نقدم إدارة شاملة للمخاطر والامتثال، بما في ذلك فحص البطاقات مرتين يومياً مقابل قوائم العقوبات واللوائح الأخرى. تضمن حلولنا المخصصة للكشف عن الاحتيال وإدارته حماية قوية، بينما يتعامل دعم العملاء المخصص مع عمليات رد المبالغ المدفوعة والنزاعات بكفاءة.',
      },
      fraud: {
        title: 'الاحتيال',
        subtitle: '& الوقاية',
        description:
          'تحلل أنظمة الكشف عن الاحتيال المتقدمة المدعومة بالتعلم الآلي المعاملات في الوقت الفعلي، وتحدد الأنماط المشبوهة وتمنع الوصول غير المصرح به قبل أن يؤثر على عملك.',
      },
      data: {
        title: 'البيانات',
        subtitle: '& الحماية',
        description:
          'يضمن التشفير الشامل وممارسات معالجة البيانات الآمنة بقاء معلوماتك الحساسة محمية في كل مرحلة من مراحل عملية المعاملة، مما يلبي معايير الامتثال العالمية.',
      },
    },
    partners: {
      description:
        'تسعى مجموعة CSC لتسهيل المعاملات التجارية من خلال مدفوعات إلكترونية سهلة ومباشرة ومستهدفة. وعلاوة على ذلك، توفر مجموعة CSC حلولاً إلكترونية ورقمية تساعد الشركات والعملاء في الحصول على ما يحتاجون إليه في أقصر وقت ممكن.',
      learnMore: 'اعرف المزيد',
    },
    trusted: {
      title: 'موثوق به من قبل\nقادة عالميين',
      description:
        'نحن فخورون بالشراكة مع بعض الشبكات والمؤسسات المالية الأكثر احتراماً في العالم لتقديم حلول دفع عالمية المستوى.',
      learnMore: 'اعرف المزيد',
    },
    footer: {
      company: 'الشركة',
      services: 'الخدمات',
      support: 'الدعم',
      about: 'عن الشركة',
      history: 'التاريخ',
      missions: 'المهام والرؤية',
      partners: 'شركاؤنا',
      news: 'الأخبار',
      publications: 'المنشورات',
      mobileApp: 'تطبيق الهاتف',
      cardIssuing: 'إصدار وإدارة البطاقات',
      atmAcquiring: 'شبكة الصراف الآلي',
      merchantAcquiring: 'خدمات التجار',
      dataCenters: 'مراكز البيانات والاتصالات',
      mobilePayment: 'الدفع عبر الهاتف',
      consultancy: 'الاستشارات',
      otherServices: 'خدمات أخرى',
      beyondCore: 'ما وراء الأساسيات',
      tools: 'الأدوات',
      careers: 'الوظائف',
      contact: 'اتصل بنا',
      privacy: 'سياسة الخصوصية والقانونية',
      dataPrivacy: 'سياسة خصوصية البيانات',
      copyright: '©2026 مجموعة CSC، جميع الحقوق محفوظة',
    },
    aboutPage: {
      hero: {
        title: 'عن المجموعة',
        subtitle:
          'منذ تأسيسنا في عام 1993، تفتخر CSC بأكثر من 30 عاماً من الخبرة المثبتة، مما يرسخ مكانتها كشريك موثوق في حلول الدفع الآمنة والمبتكرة.',
      },
      description: {
        paragraph1:
          'نحن نمكّن الأنظمة المالية عبر أكثر من 30 سوقاً في مناطق أوروبا والشرق الأوسط وشمال أفريقيا وآسيا الوسطى وأفريقيا جنوب الصحراء، بالشراكة مع أكثر من 100 بنك ومؤسسة مالية لتعزيز الكفاءة وقابلية التوسع والتحول الرقمي.',
        paragraph2:
          'انطلاقاً من 4 مواقع استراتيجية، تقدم مجموعة CSC تقنيات مرنة ومستقبلية تلبي الاحتياجات المتطورة للمشهد المالي اليوم، سواء في إصدار البطاقات أو التشغيل أو المدفوعات الرقمية.',
      },
      teamQuote:
        'تكمن قوتنا في موظفينا، فريق متنوع يضم أكثر من 200 محترف ملتزمين بالتميز والابتكار ونجاح العملاء.',
      mission: {
        label: 'مهمتنا',
        heading:
          'مهمتنا هي تمكين عملائنا من خلال تقديم حلول معالجة مدفوعات آمنة ومبتكرة وسلسة.',
        description:
          'نحن ملتزمون ببناء الثقة من خلال التكنولوجيا المتفوقة والخدمة الاستثنائية والنزاهة الراسخة، مما يدفع الشمول المالي والنمو لعملائنا ومجتمعاتهم.',
      },
      vision: {
        label: 'رؤيتنا',
        heading: 'قيادة تطور المدفوعات الرقمية وريادة الابتكارات الآمنة',
        description:
          'التي تطلق العنان للتمكين المالي والازدهار للشركات والمجتمعات عبر أسواقنا الرئيسية.',
      },
      cta: {
        heading: 'انضم إلى\nمفكرينا الجريئين',
        description:
          'نحن نبني مستقبل المدفوعات ونبحث عن مفكرين جريئين للانضمام إلينا.',
        button: 'انضم اليوم',
      },
    },
    cardIssuingPage: {
      hero: {
        title: 'إصدار البطاقات',
        subtitle:
          'حلول شاملة لبرامج البطاقات المادية والرقمية، من الإصدار الفوري إلى إدارة دورة الحياة الكاملة.',
      },
      services: {
        licensing: 'الترخيص',
        programLaunching: 'إطلاق البرنامج',
        cardIssuingProcess: 'عملية إصدار البطاقات',
        cardManagement: 'أنشطة إدارة البطاقات',
      },
      description: {
        paragraph1:
          'نقدم حلولاً شاملة ومتكاملة لبرامج البطاقات المادية والرقمية. من الإصدار والتخصيص إلى إدارة دورة الحياة الآمنة والتسوية، تدعم منصتنا مجموعة واسعة من أنواع البطاقات (الائتمان والخصم والمدفوعة مسبقاً والافتراضية).',
        paragraph2:
          'سواء كنت تطلق برنامج بطاقات جديداً أو توسع برنامجاً قائماً، نوفر المرونة والامتثال والأداء اللازم لتقديم تجارب سلسة لحاملي البطاقات وكفاءة تشغيلية.',
      },
      features: {
        replicatedData: 'بيانات مكررة',
        flexibleReporting: 'تقارير مرنة',
        automatedCardLoading: 'تحميل البطاقات الآلي',
        atmCashDeposits: 'إيداعات نقدية عبر الصراف الآلي*',
        advancedApiIntegration: 'تكامل API متقدم',
        customerSupport: 'دعم العملاء على مدار الساعة',
        issuerCmsAccess: 'وصول المُصدر إلى نظام إدارة البطاقات',
        ofacScrubbing: 'فحص OFAC والقوائم الأخرى',
        pinBySms: 'رمز PIN عبر الرسائل/البريد الإلكتروني',
        dailyReconciliation: 'المطابقة اليومية',
        secureTransaction: 'دعم المعاملات الآمنة ثلاثية الأبعاد',
        fraudMonitoring: 'مراقبة الاحتيال على مدار الساعة',
        instantIssuance: 'إصدار فوري للبطاقات',
        chargeBackSupport: 'دعم استرداد المبالغ/النزاعات',
        continuousTraining: 'تدريب مستمر',
        settlementAssociations: 'التسوية مع جمعيات البطاقات',
        dayToDaySupport: 'دعم الإدارة اليومية',
        bankingAppIntegration: 'تكامل كامل مع تطبيق البنك',
      },
      cardTypes: {
        heading:
          'تقدم CSC مجموعة شاملة من أنواع البطاقات لدعم الاحتياجات المتطورة لأعمالك',
        imageAlt:
          'أنواع البطاقات التي تقدمها CSC: مدفوعة مسبقاً، خصم، ائتمان، مشحونة، افتراضية، ذات علامة تجارية مشتركة، وبطاقات الشركات',
      },
      moreServices: 'خدمات أخرى',
    },
    merchantAcquiringPage: {
      hero: {
        title: 'خدمات\nالتجار',
        subtitle:
          'أدوات قوية لتسجيل التجار ومعالجة المعاملات وإدارة نقاط البيع مصممة للتوسع مع أعمالك.',
      },
      description: {
        paragraph1:
          'نوفر منصة مرنة وقابلة للتوسع لخدمات التجار مصممة لدعم الشركات من جميع الأحجام سواء وجهاً لوجه أو التجارة الإلكترونية. من تسجيل التجار السريع والسلس إلى معالجة المعاملات الآمنة وإدارة نقاط البيع/التجارة الإلكترونية المركزية، تساعد حلولنا المؤسسات على تقديم تجارب دفع سلسة عبر كل نقطة اتصال.',
        paragraph2:
          'مع التحليلات في الوقت الفعلي ودعم القنوات المتعددة والتكامل مع أنظمة الدفع الرئيسية؛ نمكنك من تنمية شبكة التجار الخاصة بك وتحسين العمليات والبقاء في المقدمة في سوق سريع التطور.',
      },
      features: {
        posEcommerce: 'نقاط البيع والتجارة الإلكترونية',
        statisticsDashboard: 'الوصول إلى لوحة الإحصائيات',
        fraudMonitoring: 'مراقبة الاحتيال على مدار الساعة',
        disputesManagement: 'إدارة ومعالجة النزاعات',
        mpos: 'نقاط البيع المتنقلة',
        accountManagement: 'دورة إدارة الحساب الكاملة',
        merchantInternet: 'وصول التاجر إلى الإنترنت',
        dcc: 'تحويل العملات الديناميكي',
        flexibleReporting: 'تقارير مرنة',
        customerSupport: 'دعم العملاء على مدار الساعة',
      },
      moreServices: 'خدمات أخرى',
    },
    atmAcquiringPage: {
      hero: {
        title: 'شبكة الصراف الآلي',
        subtitle:
          'منصة استحواذ قوية تربط أجهزة الصراف الآلي الخاصة بك بالشبكات الرئيسية مع المراقبة في الوقت الفعلي والتقارير ومعالجة المعاملات الآمنة.',
      },
      description: {
        paragraph1:
          'تمكّن منصة استحواذ الصراف الآلي لدينا المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية. مصممة للموثوقية والتوسع، تضمن معالجة آمنة للمعاملات ومراقبة في الوقت الفعلي وتقارير مفصلة عبر شبكة الصراف الآلي بأكملها.',
        paragraph2:
          'سواء كنت توسع شبكتك أو تعزز الكفاءة التشغيلية؛ توفر منصة CSC البنية التحتية والرؤى اللازمة لتحسين الأداء وتحسين وصول العملاء - في أي وقت وفي أي مكان.',
      },
      features: {
        atmDriving: 'تشغيل وإدارة الصراف الآلي',
        atmReconciliation: 'مطابقة الصراف الآلي',
        cashChequeDeposit: 'إيداع النقد والشيكات',
        utilityPayments: 'مدفوعات الخدمات',
        support247: 'دعم على مدار الساعة',
        fraudMonitoring: 'مراقبة الاحتيال على مدار الساعة',
        flexibleReporting: 'تقارير مرنة',
        disputeManagement: 'إدارة ومعالجة النزاعات',
        accessFee: 'رسوم الوصول',
        dcc: 'تحويل العملات الديناميكي',
      },
      moreServices: 'خدمات أخرى',
    },
    mobilePaymentsPage: {
      hero: {
        title: 'الدفع\nعبر الهاتف',
        subtitle:
          'انطلق نحو المستقبل مع حلول المحافظ الإلكترونية والترميز والتكامل مع تقنيات الدفع اللاتلامسي المصممة لمستخدمي اليوم.',
      },
      description: {
        paragraph1:
          'نمكّن المؤسسات المالية من تلبية متطلبات المستخدمين الرقميين اليوم من خلال حلول دفع عبر الهاتف آمنة وسلسة. تدعم منصتنا المحافظ الإلكترونية والترميز والتكامل اللاتلامسي، مما يضمن معاملات سريعة ومرنة وسلسة عبر الأجهزة.',
        paragraph2:
          'سواء كنت تطلق تطبيقك أو محفظتك الخاصة أو تتكامل مع تطبيقنا ذو العلامة البيضاء، نوفر الأدوات والامتثال والتكنولوجيا لمساعدتك على البقاء متصلاً وتنافسياً ومستعداً لما هو قادم.',
      },
      moreServices: 'خدمات أخرى',
    },
    consultancyPage: {
      hero: {
        title: 'استشارات\nاستراتيجية',
        subtitle:
          'إرشاد متخصص في استراتيجية المدفوعات والامتثال والتحول الرقمي، مصمم لمساعدتك على القيادة بثقة.',
      },
      description: {
        paragraph1:
          'نقدم خدمات استشارية استراتيجية لمساعدة المؤسسات على التنقل في تعقيدات مشهد المدفوعات. من تشكيل خارطة طريق التحول الرقمي إلى ضمان الامتثال التنظيمي وتحسين الأداء التشغيلي، يقدم خبراؤنا رؤى تحول التحديات إلى فرص.',
        paragraph2:
          'بفضل الخبرة الإقليمية العميقة وعقود من الخبرة العملية؛ نتشارك معك لبناء استراتيجيات مرنة وإطلاق العنان للنمو والقيادة بوضوح وثقة في نظام مالي متطور.',
      },
      moreServices: 'خدمات أخرى',
    },
    otherServicesPage: {
      hero: {
        title: 'ما وراء الأساسيات',
        subtitle:
          'ابقَ على اطلاع وتعرف على المزيد حول\nخدماتنا الجديدة والقادمة.',
      },
      services: {
        aftOct: {
          title: 'دعم كامل لتحويلات AFT و OCT',
          description:
            'إرشاد متخصص في استراتيجية المدفوعات والامتثال والتحول الرقمي، مصمم لمساعدتك على القيادة بثقة.',
        },
        bnpl: {
          title: 'برامج BNPL (اشترِ الآن وادفع لاحقاً) متكاملة بالكامل',
          description:
            'إرشاد متخصص في استراتيجية المدفوعات والامتثال والتحول الرقمي، مصمم لمساعدتك على القيادة بثقة.',
        },
        cardlessAtm: {
          title:
            'دعم السحب والإيداع بدون بطاقة ولاتلامسي من أجهزة الصراف الآلي',
          description:
            'إرشاد متخصص في استراتيجية المدفوعات والامتثال والتحول الرقمي، مصمم لمساعدتك على القيادة بثقة.',
        },
        googlePay: {
          whatsNext: 'ما التالي؟',
          title: 'دعم كامل لـ Google Pay والترميز',
          description:
            'إرشاد متخصص في استراتيجية المدفوعات والامتثال والتحول الرقمي، مصمم لمساعدتك على القيادة بثقة.',
        },
      },
      moreServices: 'خدمات أخرى',
    },
    ourToolsPage: {
      hero: {
        title: 'أدواتنا',
        subtitle:
          'ابقَ على اطلاع وتعرف على المزيد حول\nخدماتنا الجديدة والقادمة.',
      },
      tools: {
        cms: {
          title: 'تطبيق إدارة المحتوى عبر الويب (Web-Gui)',
          description:
            'توفير وصول كامل وإدارة للوظائف والمعلومات المتعلقة بحسابات حاملي البطاقات أو المعاملات بشكل فوري عبر الإنترنت.',
        },
        dataNavigator: {
          title: 'متصفح البيانات',
          description:
            'يوفر الوصول إلى معلومات المعاملات التفصيلية على حسابات بطاقات المُصدر، بالإضافة إلى نشاط أجهزة الصراف الآلي/نقاط البيع للبنك (إن وُجد).',
        },
        apiIntegration: {
          title: 'تكامل API مع تطبيق البنك/المؤسسة المالية',
          description:
            'الحصول على تفاصيل حساب البطاقة بما في ذلك التفاصيل المالية، والحصول على تفاصيل البطاقة مثل رقم البطاقة وتاريخ الانتهاء... الحصول على تفاصيل المعاملات المتعلقة بحساب بطاقة معين، وإجراء تغييرات على حساب البطاقة (حالة البطاقة، المعلمات، تغيير رمز PIN، إلخ)، وطلب إصدار البطاقة.',
        },
        dataReplication: {
          title: 'نسخ البيانات',
          description:
            'يوفر للمُصدرين القدرة على الوصول إلى بياناتهم بتنسيقها الأصلي والقدرة على استخراج التقارير وإدارة الخدمات الأخرى من جانبهم.',
        },
      },
    },
    mobileAppPage: {
      hero: {
        title: 'تطبيق\nالهاتف',
        subtitle:
          'إرشاد متخصص في استراتيجية المدفوعات والامتثال والتحول الرقمي، مصمم لمساعدتك على القيادة بثقة.',
      },
      description: {
        paragraph1:
          'عرض وإدارة جميع بطاقاتك، وتتبع ملخصات الحساب والفواتير، ومراقبة وتصفية المعاملات، والاعتراض على الرسوم، وتغيير أرقام التعريف الشخصية، وطلب كشوف حساب إلكترونية، وتحليل سلوك الإنفاق، والاستمتاع بوصول آمن مع المصادقة البيومترية.',
      },
      appFeatures: {
        label: 'ميزات التطبيق',
        viewCards: '١. عرض جميع حسابات البطاقات',
        manageCards: '٢. إدارة جميع حسابات البطاقات',
        hideShow: 'إخفاء/إظهار',
        activateDeactivate: 'تفعيل/إلغاء التفعيل',
        cancelCard: 'إلغاء البطاقة',
        accountSummary: '٣. ملخص الحساب',
        limit: 'الحد',
        totalBalance: 'الرصيد الإجمالي',
        availableToSpend: 'المتاح للإنفاق',
        minimumDue: 'الحد الأدنى المستحق',
        billingCycle: '٤. دورة الفوترة',
        transactionSummary: '٥. ملخص المعاملات',
        latestTransactions: 'أحدث المعاملات',
        transactionFilter: 'تصفية المعاملات',
        transactionHistory: 'سجل المعاملات',
        disputeTransaction: 'الاعتراض على معاملة',
        pinChange: 'تغيير رمز PIN',
        requestEstatement: 'طلب كشف حساب إلكتروني',
        spendingBehavior: 'سلوك الإنفاق',
        biometricAuth: 'المصادقة البيومترية',
      },
    },
    careersPage: {
      hero: {
        title: 'الوظائف',
        subtitle: 'في مجموعة CSC، نؤمن بأن نجاحنا يبدأ من موظفينا.',
      },
      description:
        'نحن شغوفون بالابتكار والتميز وإنشاء حلول تحدث تأثيراً. سواء كنت محترفاً ذا خبرة أو في بداية مسيرتك المهنية، نقدم فرصاً للنمو والتعلم والمساهمة في مستقبل الخدمات المالية في لبنان وخارجها.',
      howToApply: {
        title: 'كيفية التقديم؟',
        text1: 'للتقديم، يرجى إرسال سيرتك الذاتية مع رسالة تعريفية موجزة إلى',
        text2:
          'مع استخدام "طلب وظيفة" كعنوان للرسالة. سيقوم فريق التوظيف لدينا بمراجعة طلبك بعناية والتواصل معك إذا كان ملفك الشخصي يتوافق مع فرصنا الحالية.',
      },
    },
    contactPage: {
      hero: {
        title: 'اتصل بنا',
        subtitle: 'نحن هنا لمساعدتك في أي استفسارات أو دعم قد تحتاجه.',
      },
      offices: {
        cyprus: {
          title: 'المكتب الرئيسي قبرص',
        },
        lebanon: {
          title: 'لبنان:',
        },
        iraq: {
          title: 'العراق:',
        },
        dataCenter: {
          title: 'مركز البيانات واستعادة الكوارث:',
        },
      },
      map: {
        ourClients: 'عملاؤنا',
        ourOffices: 'مكاتبنا',
      },
    },
    partnersPage: {
      hero: {
        title: 'الشركاء\nالأساسيون',
        subtitle:
          'أقوى إنجازاتنا مبنية على الثقة والتعاون الذي نتشاركه مع شركائنا.',
      },
      description: {
        paragraph1:
          'في CSC، التعاون هو جوهر نجاحنا. نعمل جنباً إلى جنب مع البنوك وشركات التكنولوجيا المالية والمؤسسات الحكومية وشبكات الدفع الإقليمية وجمعيات البطاقات لإنشاء حلول مالية سلسة وآمنة ومبتكرة.',
        paragraph2:
          'شراكاتنا الدائمة مبنية على أساس من الثقة والموثوقية والالتزام بالتميز. معاً، ندفع النمو ونفتح فرصاً جديدة ونشكل مستقبل شبكة المدفوعات في جميع أنحاء المنطقة.',
      },
      grid: {
        filterAll: 'الكل',
        filterCardAssociations: 'جمعيات البطاقات',
        filterSystemsCompliance: 'أنظمة الامتثال',
        filterSoftwareHardware: 'البرمجيات والأجهزة',
        filterDataCentres: 'مراكز البيانات/موقع الاستعادة',
        partnerDescription:
          'نعمل جنباً إلى جنب مع البنوك وشركات التكنولوجيا المالية والمؤسسات الحكومية وشبكات الدفع الإقليمية وجمعيات البطاقات لإنشاء حلول مالية سلسة وآمنة ومبتكرة.',
        noPartners: 'لم يتم العثور على شركاء في هذه الفئة.',
      },
      map: {
        title: 'تواجدنا العالمي',
      },
    },
    publicationsPage: {
      hero: {
        title: 'المنشورات',
        subtitle:
          'استكشف أحدث تقاريرنا ومقالاتنا وأوراقنا البحثية التي تعرض الرؤى والخبرات.',
      },
      filterBy: 'تصفية حسب',
      filters: {
        all: 'الكل',
        reports: 'التقارير',
        articles: 'المقالات',
        research: 'الأبحاث',
      },
    },
    newsPage: {
      hero: {
        title: 'في الأخبار',
        subtitle: 'تابع أحدث شراكاتنا وإطلاقات المنتجات والإنجازات الإقليمية.',
      },
      filters: {
        all: 'جميع الأخبار',
        partnerships: 'الشراكات',
        productLaunches: 'إطلاقات المنتجات',
        milestones: 'الإنجازات',
      },
      filterBy: 'تصفية حسب',
      loadMore: 'تحميل المزيد',
    },
    newsArticle: {
      backToNews: 'العودة إلى الأخبار',
      readMore: 'اقرأ المزيد',
    },
    corporateGovernancePage: {
      hero: {
        title: 'حوكمة\nالشركات',
        subtitle: 'القيادة القوية والحوكمة الواضحة توجه كل ما نقوم به.',
      },
      description: {
        paragraph1:
          'العقول التي تقود CSC: في مجموعة CSC، تكمن قوتنا في موظفينا. من خبراء التكنولوجيا إلى قادة الصناعة، يجلب كل عضو في فريقنا خبرة عميقة وتفكيراً جديداً والتزاماً مشتركاً بالتميز.',
      },
      grid: {
        shareholders: 'المساهمون',
        boardOfDirectors: 'مجلس الإدارة',
        executiveCommittee: 'اللجنة التنفيذية',
        johnSmith: 'جون سميث',
        jessicaDoe: 'جيسيكا دو',
        reaJohnson: 'ريا جونسون',
        roleDescription:
          'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
      },
    },
    advisorsAuditorsPage: {
      hero: {
        title: 'المستشارون\nوالمدققون',
        subtitle:
          'معاً، نتعاون ونبتكر ونقود بهدف، مما يدفع نمو عملائنا ومستقبل المدفوعات.',
      },
      description: {
        paragraph1:
          'العقول التي تقود CSC: في مجموعة CSC، تكمن قوتنا في موظفينا. من خبراء التكنولوجيا إلى قادة الصناعة، يجلب كل عضو في فريقنا خبرة عميقة وتفكيراً جديداً والتزاماً مشتركاً بالتميز.',
      },
      grid: {
        auditors: 'المدققون',
        advisors: 'المستشارون',
        johnSmith: 'جون سميث',
        jessicaDoe: 'جيسيكا دو',
        reaJohnson: 'ريا جونسون',
        roleDescription:
          'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
      },
    },
    privacyPolicyPage: {
      title: 'سياسة الخصوصية والشروط القانونية',
      general: {
        heading: 'عام',
        p1: 'تصف سياسة الخصوصية هذه نوع المعلومات الشخصية التي نجمعها من عملائنا وتحدد الشروط التي نستخدم ونعالج بموجبها تلك المعلومات.',
        p2: '"البيانات الشخصية" تعني أي معلومات تتعلق بشخص محدد أو قابل للتحديد ("صاحب البيانات"). الشخص القابل للتحديد هو الشخص الذي يمكن التعرف عليه، بشكل مباشر أو غير مباشر، لا سيما بالرجوع إلى معرّف مثل: الاسم، الصورة، العنوان، البريد الإلكتروني، رقم التعريف، بيانات الموقع، معرّف عبر الإنترنت - مثل عنوان IP، أو إلى عامل أو أكثر من العوامل الخاصة بالهوية الجسدية أو الفسيولوجية أو الوراثية أو العقلية أو الاقتصادية أو الثقافية أو الاجتماعية لذلك الشخص الطبيعي.',
        p3: 'تعتبر شركة CSC Europe Limited ("CSC Europe" أو "CSC") حماية وأمن المعلومات الشخصية حقاً أساسياً لكل فرد وتتعامل مع معالجة هذه المعلومات بمسؤولية. تحدد سياسة الخصوصية هذه التزاماتنا من جهة وحقوق العملاء من جهة أخرى، وفقاً للائحة العامة لحماية البيانات في الاتحاد الأوروبي ("GDPR")، التي دخلت حيز التنفيذ في 25 مايو 2018 وأصبحت قابلة للتطبيق المباشر في جميع الدول الأعضاء في الاتحاد الأوروبي. تتبع السياسة بدقة متطلبات قانون حماية الأشخاص الطبيعيين فيما يتعلق بمعالجة البيانات الشخصية وحرية نقل هذه البيانات (القانون 125(I) لعام 2018) أيضاً.',
      },
      whyCollect: {
        heading: 'لماذا نجمع المعلومات الشخصية',
        p1: 'شركة CSC Europe Limited هي مؤسسة نقود إلكترونية تعمل بموجب الترخيص رقم 115.1.3.2 الصادر عن البنك المركزي القبرصي (www.centralbank.cy). كشركة مالية منظمة، نجمع بيانات العملاء من أجل الامتثال لالتزاماتنا القانونية المنصوص عليها في القواعد التي تحكم عملياتنا. تستخدم CSC Europe المعلومات الشخصية لتحديد والتحقق من هوية العملاء ودعمهم بإدارة سليمة للحسابات والمعاملات، وكذلك للحد بفعالية من أي تعرض للاحتيال.',
        p2: 'يقع مقرنا الرئيسي المسجل في قبرص في: 23، محكمة زخارياديس، 15، شارع نيكوديمو ميلونا، لارنكا، 6010، قبرص.',
        p3: 'يرجى الاتصال بنا إذا كان لديك أي أسئلة حول كيفية استخدام معلوماتك الشخصية على البريد الإلكتروني CSCGRP-Compliance@cscgroup.com أو بالكتابة إلينا على العنوان المسجل المذكور أعلاه.',
      },
      consent: {
        heading: 'موافقتك',
        p1: 'باستخدام مواقعنا الإلكترونية وخدماتنا، فإنك توافق وتقبل شروط سياسة الخصوصية هذه وتوافق على جمع واستخدام معلوماتك الشخصية بالطريقة الموصوفة هنا. كما تضمن أن جميع البيانات المقدمة من قبلك خلال علاقتنا التجارية دقيقة ومحدثة.',
      },
      changes: {
        heading: 'إشعار بالتغييرات',
        p1: 'قد تتم مراجعة سياسة الخصوصية هذه بمرور الوقت وقد نغير سياسة الخصوصية هذه في أي وقت عن طريق نشر نسخة منقحة منها على موقعنا الإلكتروني. ما لم يكن لدينا أسباب قانونية للقيام بخلاف ذلك، سنزودك بإشعار مسبق لا يقل عن 30 يوماً قبل تاريخ سريان سياسة الخصوصية المنقحة. قد ننشر الإشعار على موقعنا الإلكتروني و/أو نرسل لك الإشعار عبر البريد الإلكتروني. اعتباراً من تاريخ سريان سياسة الخصوصية المنقحة، ستُعتبر موافقاً على جميع التغييرات في سياسة الخصوصية.',
        p2: 'إذا كنت لا توافق على شروط سياسة الخصوصية هذه، يمكنك إنهاء اتفاقيتنا وإغلاق حسابك في أي وقت. نشجعك على زيارة موقع الشركة الإلكتروني بشكل دوري للبقاء على اطلاع بأي تغييرات لاحقة في سياسة الخصوصية الخاصة بنا.',
        p3: 'تم تحديث هذه السياسة آخر مرة في 2 أكتوبر 2025.',
      },
      infoCollect: {
        heading: 'نوع المعلومات الشخصية والوثائق التي نجمعها',
        p1: 'نجمع المعلومات الشخصية والوثائق عنك عند التقدم لتصبح عميلاً وفتح حساب لدى CSC Europe. قد تشمل هذه المعلومات: اسمك، تاريخ ميلادك، جنسيتك، عنوان منزلك، تفاصيل المهنة، معلومات الاتصال مثل رقم الهاتف وعنوان البريد الإلكتروني، وكذلك معلومات التحقق من الهوية بما في ذلك: صور وثيقة الهوية الحكومية (جواز السفر، بطاقة الهوية الوطنية أو رخصة القيادة)، ومعلومات التحقق من الإقامة مثل تفاصيل فاتورة المرافق أو معلومات مماثلة.',
        device: 'استخدام جهازك:',
        p2: 'عند استخدام خدمات CSC Europe باستخدام أي جهاز، قد نجمع ونخزن بيانات تسجيل الدخول للجهاز (بما في ذلك على سبيل المثال لا الحصر معرف الجهاز) وبيانات الموقع من أجل تقديم خدماتنا بأفضل تجربة مستخدم.',
        p3: 'نجمع معلومات حول الصفحات التي تزورها على موقعنا الإلكتروني، وعناوين IP، ونوع المتصفح الذي تستخدمه وأوقات وصولك إلى موقعنا.',
        communications: 'الاتصالات:',
        p4: 'عندما تتواصل معنا لخدمة العملاء أو لأغراض أخرى (مثل رسائل البريد الإلكتروني والمكالمات الهاتفية والفاكسات وما إلى ذلك)، نحتفظ بهذه المعلومات وردودنا عليك في سجلات حسابك.',
      },
      cookies: {
        heading: 'سياسة ملفات تعريف الارتباط',
        whatAreCookies: 'ما هي ملفات تعريف الارتباط؟',
        p1: 'ملف تعريف الارتباط هو ملف صغير من الحروف والأرقام يتم تنزيله على جهاز (كمبيوتر، هاتف ذكي، إلخ) عندما يصل المستخدم إلى مواقع ويب معينة. تسمح ملفات تعريف الارتباط لموقع الويب بالتعرف على جهاز المستخدم وتذكر المعلومات الأساسية والعمل بطريقة أفضل وأكثر كفاءة.',
        categories: 'فئات مختلفة من ملفات تعريف الارتباط:',
        firstParty: 'ملفات تعريف الارتباط الخاصة بالطرف الأول.',
        firstPartyDesc:
          'يتم تعيين ملفات تعريف الارتباط الخاصة بالطرف الأول بواسطة الموقع الذي يتصفحه المستخدم ولا يمكن قراءتها إلا بواسطة هذا الموقع بالذات.',
        thirdParty: 'ملفات تعريف الارتباط الخاصة بالطرف الثالث.',
        thirdPartyDesc:
          'يتم تعيين ملفات تعريف الارتباط الخاصة بالطرف الثالث بواسطة منظمة مختلفة عن مالك الموقع الذي تتم زيارته.',
        session: 'ملفات تعريف الارتباط للجلسة.',
        sessionDesc:
          'يتم تخزين ملفات تعريف الارتباط للجلسة مؤقتاً فقط أثناء جلسة التصفح ويتم حذفها من جهاز المستخدم عند إغلاق المتصفح.',
        persistent: 'ملفات تعريف الارتباط الدائمة.',
        persistentDesc:
          'يتم حفظ هذا النوع من ملفات تعريف الارتباط على الكمبيوتر لفترة محددة (ولا يتم حذفها عند إغلاق المتصفح).',
        weUse: 'ملفات تعريف الارتباط التي نستخدمها:',
        p2: 'نستخدم ملفي تعريف ارتباط ضروريين لعمل برنامج الخادم الخلفي (ColdFusion) بشكل صحيح: CFID و CFTOKEN.',
        p3: 'نستخدم ملفات تعريف ارتباط الطرف الثالث والدائمة لتزويدك بوظائف إضافية للموقع.',
        p4: 'يمكنك العثور على معلومات إضافية حول ملفات تعريف الارتباط على: http://www.allaboutcookies.org/',
        p5: 'بالاستمرار في استخدام مواقعنا الإلكترونية، فإنك توافق على استخدام ملفات تعريف الارتباط هذه وعلى سياسة ملفات تعريف الارتباط الخاصة بنا.',
      },
      howWeUse: {
        heading: 'كيف نستخدم معلوماتك الشخصية',
        p1: 'نستخدم معلوماتك الشخصية لخدمة حسابك وتحسين خدمتنا لك.',
        p2: 'نلتزم بدقة بالمبادئ التالية عند استخدام بياناتك الشخصية:',
        a: 'نبذل قصارى جهدنا لضمان معالجة معلوماتك الشخصية بشكل قانوني وعادل وشفاف',
        b: 'نحد من المعلومات الشخصية المجمعة منك إلى ما هو ضروري فيما يتعلق بالأغراض التي تتم معالجتها من أجلها ونحاول الحفاظ على دقة هذه المعلومات وتحديثها',
        c: 'نخزن بياناتك الشخصية لفترات لا تزيد عن اللازم للأغراض التي تتم معالجتها من أجلها. سنحتفظ بمعلوماتك ونستخدمها حسب الحاجة للامتثال لالتزاماتنا القانونية',
        d: 'نطبق التدابير اللازمة لمعالجة بيانات العملاء بطريقة تضمن أمنها وسلامتها وسريتها',
        p3: 'تجمع CSC معلوماتك الشخصية للأغراض المذكورة أدناه وتوافق على أنه يجوز لنا استخدام تلك المعلومات من أجل:',
        useA: 'التحقق من هويتك والامتثال للقوانين واللوائح المعمول بها المتعلقة بمنع غسل الأموال وتمويل الإرهاب',
        useB: 'معالجة معاملاتك',
        useC: 'إدارة المخاطر واكتشاف ومنع الاحتيال أو الاستخدامات غير القانونية الأخرى لخدماتنا',
        useD: 'مساعدتنا في الاستجابة لطلباتك للخدمات والدعم',
        useE: 'الاتصال بك وإبلاغك بالمعلومات والتحديثات المتعلقة باستخدامك لخدماتنا وأي معلومات مهمة أخرى',
        useF: 'اكتشاف أو معالجة انتهاكات سياساتنا والاتفاقيات المعمول بها',
      },
      communication: {
        heading: 'تواصلنا معك',
        p1: 'نتواصل مع عملائنا عبر البريد الإلكتروني لتقديم الخدمات المطلوبة. قد نتواصل أيضاً مع العملاء عبر الهاتف من أجل:',
        item1: 'حل الشكاوى أو المطالبات',
        item2: 'الاستجابة لطلبات خدمة العملاء',
        item3:
          'الإبلاغ عن الاستخدام غير المشروع للحسابات أو المعاملات المشبوهة',
        item4: 'تأكيد المعلومات المتعلقة بهوية العميل أو أعماله أو نشاط حسابه',
        p2: 'نستخدم بريدك الإلكتروني أو عنوانك البريدي لتأكيد فتح حسابك، ولإرسال رمز تفعيل بطاقتك المدفوعة مسبقاً، ولإرسال معلومات حول التغييرات في منتجاتنا وخدماتنا، ولإرسال الإشعارات والإفصاحات الأخرى المطلوبة بموجب القانون.',
        p3: 'قد نتواصل معك كما هو موضح أعلاه عبر الرسائل القصيرة لإرسال تنبيهات إشعارات المعاملات أو رموز لمعالجة معاملات معينة على حسابك.',
      },
      disclosure: {
        heading: 'الإفصاح عن معلوماتك الشخصية لأطراف ثالثة',
        p1: 'هناك ظروف قد نحتاج فيها إلى مشاركة بياناتك الشخصية. قد نحتاج إلى القيام بذلك لمساعدتنا في تنفيذ عملياتنا.',
        p2: 'عند معالجة معاملاتك، قد نفصح عن معلوماتك الشخصية لأطراف ثالثة وللسلطات القانونية والتنظيمية.',
        thirdParties: 'الإفصاح لأطراف ثالثة',
        p3: 'لن يتم بيع معلوماتك أو تبادلها أو مشاركتها مع أي أطراف ثالثة دون موافقتك، إلا عندما يقتضي القانون ذلك.',
        p4: 'مقدمو خدمات الطرف الثالث ملزمون تعاقدياً معنا بحماية واستخدام بياناتك الشخصية فقط للأغراض التي تم الإفصاح عنها من أجلها ونضمن أن هذه الأطراف الثالثة تخضع لنفس القواعد الوقائية الموصوفة في سياسة الخصوصية هذه.',
        p5: 'لا يمكن للأطراف الثالثة استخدام معلومات التعريف الشخصية حول عملائنا لأي أغراض ثانوية دون موافقتك الصريحة.',
        p6: 'توافق على أنه يجوز لنا مشاركة معلوماتك الشخصية مع:',
        shareA:
          'شركاء خدمة الطرف الثالث الذين يعملون نيابة عنا كمعالجي بيانات، مع أي عضو في مجموعتنا أو مع شركتنا القابضة النهائية',
        shareB:
          'أطراف ثالثة مختارة بما في ذلك شركاء الأعمال أو الوكلاء لتنفيذ أي عقد ندخل فيه معهم أو معك',
        thirdPartySites: 'مواقع الطرف الثالث',
        p7: 'إذا فتحت حساب CSC Europe مباشرة على موقع طرف ثالث أو عبر تطبيق طرف ثالث، فإن أي معلومات تدخلها على ذلك الموقع أو التطبيق ستتم مشاركتها مع مالك موقع أو تطبيق الطرف الثالث.',
        legalAuthorities: 'الإفصاح للسلطات القانونية',
        p8: 'قد نشارك معلوماتك الشخصية مع الجهات التنظيمية ووكالات إنفاذ القانون وسلطات حماية البيانات والمسؤولين الحكوميين أو السلطات الأخرى في الحالات التالية:',
        legalA:
          'فيما يتعلق بطلب رسمي أو أمر استدعاء أو أمر محكمة أو إجراء قانوني آخر',
        legalB:
          'عندما نعتقد بحسن نية أن الإفصاح ضروري لمنع غسل الأموال أو تمويل الإرهاب أو التهرب الضريبي أو أي نشاط غير قانوني آخر',
        legalC:
          'الإفصاح ضروري للتحقيق في انتهاكات سياسة الخصوصية هذه أو شروطنا وأحكامنا أو لمنع الخسارة المالية',
        p9: 'بتقديم بياناتك الشخصية، فإنك توافق على هذا الإفصاح أو النقل أو المعالجة. سنتخذ جميع الخطوات المعقولة اللازمة لضمان معاملة بياناتك بأمان ووفقاً لسياسة الخصوصية هذه.',
      },
      storage: {
        heading: 'كيف نخزن معلوماتك الشخصية',
        p1: 'يتم تخزين المعلومات الشخصية التي تقدمها لنا على خوادمنا بشكل آمن. يتم تشفير معاملات الدفع باستخدام خوارزميات تشفير قوية.',
        p2: 'أنت مسؤول عن الحفاظ على سرية أي بيانات اعتماد أمنية مقدمة لك للوصول إلى موقعنا وحسابك الشخصي. نطلب منك عدم مشاركتها مع أي شخص.',
      },
      retention: {
        heading: 'الاحتفاظ بمعلوماتك الشخصية',
        p1: 'من أجل الامتثال لالتزاماتنا القانونية المتعلقة بمنع غسل الأموال ومكافحة تمويل الإرهاب، يُطلب منا الاحتفاظ بالوثائق والمعلومات التالية حول عملائنا لمدة لا تقل عن خمس (5) سنوات بعد انتهاء علاقة العمل:',
        a: 'نسخ من الوثائق والمعلومات المطلوبة للامتثال لمتطلبات العناية الواجبة للعملاء كما هو محدد في قوانين منع وقمع غسل الأموال وتمويل الإرهاب لعام 2007-2022',
        b: 'الأدلة والسجلات ذات الصلة بالمعاملات الضرورية لتحديد المعاملات',
        c: 'وثائق المراسلات ذات الصلة مع العملاء',
        p2: 'يمكننا الاحتفاظ بالوثائق والمعلومات الشخصية لعملائنا لمدة خمس (5) سنوات إضافية حيث يكون الاحتفاظ الإضافي مبرراً لغرض منع أو اكتشاف أو التحقيق في غسل الأموال وتمويل الإرهاب.',
        p3: 'بتقديم بياناتك الشخصية، فإنك توافق على هذا التخزين والاحتفاظ بسجلاتك. سنتخذ جميع الخطوات المعقولة اللازمة لضمان معاملة بياناتك بأمان ووفقاً لسياسة الخصوصية هذه.',
      },
      security: {
        heading: 'أمن معلوماتك الشخصية',
        p1: 'نستخدم مجموعة متنوعة من التدابير الأمنية لضمان سرية معلوماتك الشخصية وحمايتها من الفقدان والسرقة والوصول غير المصرح به وسوء الاستخدام والتغيير أو التدمير. نلتزم بمعايير PCI DSS واللائحة العامة لحماية البيانات (GDPR) لحماية البيانات وقد نفذنا تدابير أمنية تشمل على سبيل المثال لا الحصر:',
        item1: 'وصول مقيد إلى المعلومات الشخصية',
        item2: 'سياسات صارمة بشأن وصول المستخدمين',
        item3:
          'أمان طبقة النقل (TLS) لضمان سرية معلوماتك أثناء النقل عبر الشبكة الداخلية أو العامة',
        item4: 'تقوية الأنظمة لحماية خوادمنا من الثغرات والهجمات',
        item5: 'اختبار دوري لضمان كفاية تدابيرنا الأمنية',
        item6: 'مسارات التدقيق لتتبع التغييرات على معلوماتك الشخصية',
        p2: 'لمنع فقدان البيانات، يتم نسخ المعلومات احتياطياً بانتظام. تستخدم جميع قواعد بياناتنا التشفير لحماية البيانات في حالة السكون. علاوة على ذلك، يتم تشفير جميع البيانات الحساسة قبل نقلها إلكترونياً.',
        p3: 'يُسمح فقط للموظفين المصرح لهم بالوصول إلى معلوماتك الشخصية، ويُطلب من هؤلاء الموظفين التعامل مع المعلومات على أنها سرية للغاية.',
      },
      gdpr: {
        heading:
          'حقوقك في حماية البيانات الشخصية بموجب اللائحة العامة لحماية البيانات',
        p1: 'كفرد، لديك حقوق معينة بموجب اللائحة العامة لحماية البيانات فيما يتعلق باستخدام معلوماتك الشخصية. تشمل هذه الحقوق ما يلي:',
        right1:
          'لديك الحق في الوصول إلى معلوماتك الشخصية ومعرفة البيانات التي نحتفظ بها عنك ولأي غرض تتم معالجتها. يمكنك طلب تزويدك بهذه المعلومات كتابياً عبر البريد الإلكتروني أو الرسالة. سنرد عليك خلال شهر من استلام طلبك.',
        right2:
          'لديك الحق في الحصول دون تأخير غير مبرر على تصحيح البيانات الشخصية غير الدقيقة التي نحتفظ بها عنك.',
        right3:
          'لديك الحق في الاعتراض على أو تقييد معالجة معلوماتك الشخصية في أي وقت.',
        right4:
          'يمكنك توجيهنا لمشاركة معلوماتك الشخصية مع أطراف أخرى بناءً على توجيهك الكتابي وموافقتك الصريحة.',
        right5: 'يمكنك سحب موافقتك على معالجة بياناتك الشخصية في أي وقت.',
        p2: 'يمكنك إرسال هذه الطلبات إلى البريد الإلكتروني: CSCGRP-Compliance@cscgroup.com أو بالبريد إلى العنوان المسجل لشركتنا.',
      },
      complain: {
        heading: 'إذا كنت ترغب في تقديم شكوى',
        p1: 'شركتنا مسؤولة عن ضمان امتثال إجراءاتنا اليومية لسياسة الخصوصية هذه. إذا كنت ترغب في ممارسة حقك في الوصول إلى معلوماتك أو لديك أي أسئلة حول سياسة الخصوصية هذه أو ترغب في تقديم شكوى حول كيفية استخدام بياناتك الشخصية من قبل CSC Europe، يمكنك الاتصال بنا إلكترونياً على عنوان البريد الإلكتروني المذكور أعلاه أو بالكتابة إلى عنواننا المسجل.',
        p2: 'عند استلام شكواك، سنحقق فيها ونرد عليك خلال شهر. في حالة عدم إمكانية الالتزام بهذا الموعد النهائي، سنوضح لك السبب ونبلغك بالوقت الممتد للرد.',
        supervisory: 'حقك في تقديم شكوى إلى السلطة الإشرافية',
        p3: 'إذا كنت تعتقد أن CSC Europe لم تحل شكواك بطريقة مرضية، فلديك الحق في تقديم شكوى إلى السلطة الإشرافية. تفاصيلهم هي:',
        office: 'مكتب مفوض حماية البيانات الشخصية في قبرص',
        address1: '1، شارع ياسونوس، 1082 نيقوسيا',
        address2: 'صندوق بريد 23378، 1682 نيقوسيا',
        tel: 'هاتف: +357 22818456',
        fax: 'فاكس: +357 22304565',
        email: 'البريد الإلكتروني: commissioner@dataprotection.gov.cy',
      },
    },
  },
}
